import CollectionFilter from './collection-filter'

export default class CollectionAlternateFilter {
  constructor () {
    this.wrapper = document.getElementById('collection-alternate-filter')
    this._filterOptions = document.querySelectorAll('.collection-filter')
    this.collection = undefined
  }

  async init () {
    this.wrapper.addEventListener('change', (event) => {
      this.collection = event.target.value

      this.wrapper.dispatchEvent(new CustomEvent(CollectionFilter.EVENT.CHANGE, {
        bubbles: true,
        detail: { collection: this.collection }
      }))
    })
  }

  filterIsSet () {
    return this.collection !== undefined
  }
}
